var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","stroke":"none","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M15.9844 11.0156V3H8.01562V9H2.01562V21H21.9844V11.0156H15.9844ZM9.98438 5.01562H14.0156V18.9844H9.98438V5.01562ZM3.98438 11.0156H8.01562V18.9844H3.98438V11.0156ZM20.0156 18.9844H15.9844V12.9844H20.0156V18.9844Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }